/**
 * axios setup to use mock service
 */

import axios from 'axios';
import { STYRK_API } from 'config';
import { dispatch } from 'store';
import { openSnackbar } from 'store/slices/snackbar';
import { ConnectionError, ForbiddenError } from './customErrors';
import { getUpdatedToken } from 'contexts/AWSCognitoContext';

const axiosServices = axios.create({
    ...(STYRK_API && { baseURL: STYRK_API })
});
const axiosServicesHC = axios.create();

axiosServices.interceptors.request.use(async (config) => {
    const token = await getUpdatedToken();

    if (token && config && config.headers && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

axiosServices.interceptors.response.use(
    (response) => response,
    async (err) => {
        if (err.response?.status === 403) {
            if (err.response.statusText === 'IP-DomainBlocked') {
                setTimeout(() => {
                    dispatch(
                        openSnackbar({
                            message: 'Connection error. Check your network permissions.',
                            variant: 'error'
                        })
                    );
                }, 500);
                throw new ConnectionError();
            } else {
                dispatch(
                    openSnackbar({
                        message: "You're not allowed to view this content. Check your user permissions.",
                        variant: 'error'
                    })
                );
                throw new ForbiddenError();
            }
        }
        return Promise.reject(err);
    }
);

axiosServicesHC.interceptors.request.use((config) => {
    const token = localStorage.getItem('serviceTokenHC');

    if (token && config && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

axiosServicesHC.interceptors.response.use(
    (response) => response,
    (err) => {
        if (err.response?.status === 403 && err.response.statusText === 'IP-DomainBlocked') {
            setTimeout(() => {
                dispatch(
                    openSnackbar({
                        message: 'Connection error. Check your network permissions.',
                        variant: 'error'
                    })
                );
            }, 500);
        }
        return Promise.reject(err);
    }
);

// // interceptor for http

export default axiosServices;
